<template>
  <loader v-if="loading" />
  <div v-else>
      <h2 class="mb-2">User Information</h2>
      <p class="mb-6">Updating the information below will apply changes to the {{selectedOfficeName}} microsite only and is intended for use by those with multiple positions, email addresses and/or phone numbers. If you wish to update your user information and apply changes to all of your associated microsites, use the Edit function on the Staff tab.</p>
      <div class="flex flex-wrap -mx-2 mt-4">
        <div class="w-full px-2 mb-6">
          <label class="mb-2 font-bold">Position: </label>
          <input type="text" v-model="user.position_name" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" placeholder="Position" />
          <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('position_name')" v-text="errorBag.get('position_name')"></small>
        </div>
        <div class="w-full px-2 mb-6">
          <label class="mb-2 font-bold">Email: </label>
          <input type="text" v-model="user.email_address" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" placeholder="Email" />
          <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('email_address')" v-text="errorBag.get('email_address')"></small>
        </div>
        <div class="w-full px-2 mb-6">
          <label class="mb-2 font-bold">Phone: </label>
          <input type="text" v-model="user.phone_number" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" placeholder="Phone" />
          <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('phone_number')" v-text="errorBag.get('phone_number')"></small>
        </div>
      </div>
      <div class="flex justify-end">
        <button @click="saveUserAssociate" class="bg-primary rounded py-3 px-12 text-white" :disabled="saving">
          <loader v-if="saving" fill-color="white" />
          <span v-else>Save</span>
        </button>
      </div>
    </div>
</template>

<script>
import api from '@/http'
import { mapActions } from 'vuex'
import ErrorBag from '@/ErrorBag'
export default {
  name: 'UserAssociateModal',
  props: {
    selectedAssociateofficeId: Number,
    selectedAssociateuserId: Number,
    selectedOfficeName: String
  },
  data () {
    return {
      errorBag: new ErrorBag(),
      saving: false,
      errors: null,
      user: {
        position_name: null,
        email_address: null,
        phone_number: null
      },
      loading: true
    }
  },
  methods: {
    ...mapActions([
      'displayToastNotification'
    ]),
    saveUserAssociate () {
      this.saving = true
      this.errorBag.clear()
      let params = {
        office_id: this.selectedAssociateofficeId,
        user_id: this.selectedAssociateuserId,
        position_name: this.user.position_name,
        email_address: this.user.email_address,
        phone_number: this.user.phone_number
      }
      api.patch('/update-user-office-associate-details', params).then(
        response => {
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'User information updated',
            info: 'User information details have been updated successfully.'
          })
          this.$emit('close-user-associate-modal')
        },
        error => {
          this.errorBag.store(error.response.data)
          this.saving = false
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-times-circle',
            title: 'User information',
            info: 'Error while saving details.'
          })
        }
      )
    },
    getUserAssociateDetails () {
      api.get('/user-office-associate-details/' + this.selectedAssociateofficeId + '/' + this.selectedAssociateuserId).then(response => {
        this.user = response.data
        this.loading = false
      }).catch(({ response }) => {
      })
    }
  },
  created () {
    this.getUserAssociateDetails()
  }
}
</script>
